const stateRoot = (state) => state.history_filter;

export const getSelectedDate = (state) => stateRoot(state).selectedDate;
